// Sistem log servisi
// Veritabanına log kaydetmek için kullanılır

const API_BASE_URL = process.env.REACT_APP_API_BASE_URL || '';

/**
 * Sistem logu kaydet
 * @param {string} level - Log seviyesi: INFO, SUCCESS, WARNING, ERROR
 * @param {string} category - Log kategorisi: login, logout, database, email, report, system
 * @param {string} message - Log mesajı
 * @param {object} metadata - Ek bilgiler (opsiyonel)
 */
export const logEvent = async (level, category, message, metadata = {}) => {
  try {
    if (!API_BASE_URL) {
      console.warn('⚠️ Backend API endpoint tanımlı değil. Log kaydedilemedi.');
      return;
    }

    // Kullanıcı bilgilerini al (varsa)
    const userEmail = metadata.userEmail || null;
    const userRole = metadata.userRole || null;

    const response = await fetch(`${API_BASE_URL}/api/logs`, {
      method: 'POST',
      headers: {
        'Content-Type': 'application/json',
      },
      body: JSON.stringify({
        level,
        category,
        message,
        userEmail,
        userRole,
        metadata: {
          ...metadata,
          userEmail: undefined, // metadata'dan çıkar çünkü ayrı field'da
          userRole: undefined, // metadata'dan çıkar çünkü ayrı field'da
        },
      }),
    });

    if (!response.ok) {
      console.error('❌ Log kaydedilemedi:', response.statusText);
    }
  } catch (error) {
    // Log kaydetme hatası kritik değil, sessizce geç
    console.warn('⚠️ Log kaydetme hatası:', error.message);
  }
};

/**
 * Sistem loglarını getir
 * @param {number} limit - Kaç log getirilecek (varsayılan: 100)
 * @param {number} offset - Kaç log atlanacak (pagination için, varsayılan: 0)
 * @param {string} level - Filtreleme için log seviyesi (opsiyonel)
 * @param {string} category - Filtreleme için kategori (opsiyonel)
 */
export const getLogs = async (limit = 100, offset = 0, level = null, category = null) => {
  try {
    if (!API_BASE_URL) {
      console.warn('⚠️ Backend API endpoint tanımlı değil.');
      return [];
    }

    const params = new URLSearchParams({ 
      limit: limit.toString(),
      offset: offset.toString()
    });
    if (level) params.append('level', level);
    if (category) params.append('category', category);

    const response = await fetch(`${API_BASE_URL}/api/logs?${params.toString()}`);
    
    if (!response.ok) {
      throw new Error('Loglar yüklenemedi');
    }

    const data = await response.json();
    return data.logs || [];
  } catch (error) {
    console.error('❌ Loglar yüklenemedi:', error);
    return [];
  }
};

